/**
* 操作修改state的值
**/
import { SETT_ABBAR, SET_TABS } from './mutations-type'
import { refresh } from 'less';
const Mutations = {
    [SETT_ABBAR](state, val) {
        state.idxs = val
    },
    [SET_TABS](state, val) {
        state.idx = val.index;
        state.type = val.type;

    },
    // 用户端登录获取Token
    getToken(state, val) {
        state.token = val[0];
        state.loginType = val[1];
    },
    // 用户端首页筛选
    select(state, val) {
        if (val[3] == 0) {
            switch (typeof val) {
                case 'object':
                    state.list = val
                    break;
                case 'number'://清除
                    state.list = []
                    break;
            }
        } else {
            switch (typeof val) {
                case 'object':
                    state.lists = val
                    break;
                case 'number'://清除
                    state.list = []
                    break;
            }
        }

    },
    // 用户端筛选数量
    selectNum(state, val) {

        if (val[1] === 0) {
            state.selectNum = val
        } else {
            state.selectNums = val
        }

    },
    // 用户端地址筛选
    selectAddress(state, val) {
        if (val[2] == 0) {
            if (val[3] == 'type') {
                state.selectInfo = []
            } else {
                state.selectInfo = val
            }

        } else if (val[2] == 1) {
            if (val[3] == 'type') {
                state.selectInfos = []
            } else {
                state.selectInfos = val
            }
        } else {
            state.companyAddress = val
        }
    },
    // 用户登录密码
    getPassword(state, val) {
        state.password = val
    },
    // 用户手机号
    getTelphone(state, val) {
        state.telphone = val
    },
    // 用户搜索
    userSearch(state, val) {
        state.searchArray = val
    },
    // 企业注册信息
    companyRegister(state, val) {
        state.params = val
    },
    // 用户端注册信息收集
    userRegister(state, val) {
        state.userParams = val
    },
    // 组件缓存
    keepAliveRouter(state, val) {

        state.keepAliveRoute = val
    },
    // 微信登录code刷新
    refreshCode(state, val){
        //(val);
        state.logins=val
    }


}

export default Mutations